// extracted by mini-css-extract-plugin
export default {"wrapper":"PostList_wrapper__N0nXE"};